import DetailTitle from "@/components/DetailTitle";
import React from 'react'
import { useRef, useEffect } from "react";
import { Row, Col, Alert, Input, DatePicker, InputNumber } from "antd";
import { GlobalOutlined } from '@ant-design/icons';
import "./index.css"
import styles from "./index.module.scss";
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style';
import 'ol/ol.css';
import 'ol-layerswitcher/dist/ol-layerswitcher.css';
import LayerSwitcher from 'ol-layerswitcher';
import dayjs from 'dayjs';
import intl from "react-intl-universal";

const { RangePicker } = DatePicker;
let map = null; //地图全局变量

const Coverage = ({ mapObj, setMapObj }) => {
	// const [type, setType] = useState("point")
	const type = "point";
	// openlayers将会渲染进这个div
	const mapRef = useRef()
	const projection = 'EPSG:4326'
	const tk = '8c471ad83d563e443d9a630de25f23a0'
	const center = [mapObj.longitude, mapObj.latitude]; //地图中心位置  武大 -- 114.
	const iconFeature = new Feature({
		geometry: new Point(center),
		name: 'Null Island',
		population: 4000,
		rainfall: 500,
	});

	const dateFormat = 'YYYY-MM-DD';
	const iconStyle = new Style({
		image: new Icon({
			anchor: [0.5, 46],
			anchorXUnits: 'fraction',
			anchorYUnits: 'pixels',
			src: '/assets/location.png',
		}),
	});

	iconFeature.setStyle(iconStyle);


	useEffect(() => {
		map = new Map({
			view: new View({
				center: (center[0] && center[1]) ? center : [0, 0], //地图中心位置  武大 -- 114.36, 30.54
				projection,//地图投影方式
				zoom: (center[0] && center[1]) ? 10 : 1,//地图初始层级
				maxZoom: 15,
				minZoom: 1
			}),
			controls: [],
			layers: [
				new TileLayer({
					title: "天地图矢量图层",
					source: new XYZ({
						url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_c&tk=${tk}&x={x}&y={y}&l={z}`,
						projection,
					}),
				}),
				new TileLayer({
					title: "天地图矢量图层注记",
					source: new XYZ({
						url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_c&tk=${tk}&x={x}&y={y}&l={z}`,
						projection,
					}),
				}),
				new TileLayer({
					title: "谷歌影像",
					source: new XYZ({
						url: 'https://www.google.com/maps/vt?lyrs=s&gl=cn&x={x}&y={y}&z={z}',
						projection: 'EPSG:3857',
					}),
					visible: false
				})
			],
			target: mapRef.current
		});

		const iconVecLayer = new VectorLayer({
			name: 'iconVecLayer',
			source: new VectorSource({
				features: [iconFeature],
			})
		})

		// if (center[0] && center[1]) {
		// 	map.addLayer(iconVecLayer);
		// }
		map.on('singleclick', (evt) => {
			const coordinate = evt.coordinate;
			// 更新mapObj状态
			setMapObj({
				longitude: coordinate[0].toFixed(6),
				latitude: coordinate[1].toFixed(6),
			});
		})

		const layerSwitcher = new LayerSwitcher({
			reverse: true,
			groupSelectStyle: 'group'
		});

		console.log(iconVecLayer)
		map.addControl(layerSwitcher);
		map.addLayer(iconVecLayer);

		// 卸载组件时清除地图实例
		return () => {
			if (map) {
				map.setTarget(null); // 解除地图绑定
				map.dispose(); // 销毁地图
			}
		}
	}, [])

	useEffect(() => {
		if (map && mapObj.longitude && mapObj.latitude) {
			const layer = map.getLayers().getArray().find(layer => layer.get('name') === 'iconVecLayer')
			layer?.getSource().clear()
			iconFeature.setGeometry(new Point([mapObj.longitude, mapObj.latitude]));
			layer.setSource(new VectorSource({
				features: [iconFeature],
			}))
			map.getView().setCenter([mapObj.longitude, mapObj.latitude])
			map.getView().setZoom(10)
		}
	}, [mapObj])

	return (
		<div className={styles.coverageBox}>
			<DetailTitle title="Spatial & Temporal" />
			<Alert
				showIcon
				title={intl.get('Share.mapDes')}
				type="info"
			/>
			<h3>{intl.get('Share.Spatial')}</h3>
			<Row gutter={40}>
				<Col span={8}>
					<div className={styles.leftBox}>
						<div><span>{intl.get('Share.Place/Area Name')}</span></div>
						<Input value={mapObj.areaName} onChange={(e) => {
							setMapObj({ ...mapObj, areaName: e.target.value })
						}} />
						<div>
							<GlobalOutlined style={{ marginRight: "5px" }} />
							{intl.get('Share.Coordinate System/Geographic Projection')}WGS 84 EPSG:4326
						</div>
						<div>{intl.get('Share.Decimal degrees')}</div>
						{type === "point" &&
							<React.Fragment>
								<InputNumber value={mapObj.longitude} onChange={(e) => {
									setMapObj({ ...mapObj, longitude: e })
								}} min={-180} max={180} addonBefore={intl.get('Share.Longitude')} placeholder="-180 to 180" addonAfter="°" />
								<InputNumber value={mapObj.latitude} onChange={(e) => {
									setMapObj({ ...mapObj, latitude: e })
								}} min={-90} max={90} addonBefore={intl.get('Share.Latitude')} placeholder="-90 to 90" addonAfter="°" />
							</React.Fragment>
						}

						{/*type === "box" &&
							<React.Fragment>
								<InputNumber min={-90} max={90} addonBefore="North Latitude" placeholder="-90 to 90" addonAfter="°" />
								<InputNumber min={-180} max={180} addonBefore="East Longitude" placeholder="-180 to 180" addonAfter="°" />
								<InputNumber min={-90} max={90} addonBefore="South Latitude" placeholder="-90 to 90" addonAfter="°" />
								<InputNumber min={-180} max={180} addonBefore="West Longitude" placeholder="-180 to 180" addonAfter="°" />
							</React.Fragment>
						*/}
					</div>
				</Col>
				<Col span={16}>
					<div className={styles.rightBox}>
						{/*<Radio.Group onChange={(e) => {
							setType(e.target.value)
						}} value={type}>
							<Radio value="point">Point</Radio>
							<Radio value="box">Box</Radio>
						</Radio.Group>*/}
						<div ref={mapRef} className={styles.mapBox}></div>
					</div>
				</Col>
			</Row>
			<h3>{intl.get('Share.Temporal')}</h3>
			<RangePicker
				format="YYYY-MM-DD"
				value={mapObj.startDate ? [dayjs(mapObj.startDate, dateFormat), dayjs(mapObj.endDate, dateFormat)] : []}
				onChange={(e, date) => {
					setMapObj({
						...mapObj,
						startDate: date[0] || "",
						endDate: date[1] || "",
					})
				}} />
		</div>
	)
}
export default Coverage;